<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          v-model="form.salutation_id"
          :items="salutations"
          :clearable="!readonly"
          item-text="long_name"
          item-value="id"
          :label="$t('PROFILE.SALUTATION')"
          :readonly="readonly"
          :error-messages="errors.salutation"
          @change="updateValue('salutation_id', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.first_name"
          :label="`${$t('PROFILE.FIRST_NAME')} *`"
          :rules="rules.requiredTextLine"
          :readonly="readonly"
          :error-messages="errors.first_name"
          @input="updateValue('first_name', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.last_name"
          :label="`${$t('PROFILE.LAST_NAME')} *`"
          :rules="rules.requiredTextLine"
          :readonly="readonly"
          :error-messages="errors.last_name"
          @input="updateValue('last_name', $event)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-select
          v-model="form.language_id"
          :items="languages"
          item-value="id"
          item-text="name"
          :label="$t('PROFILE.LANGUAGE')"
          :readonly="readonly"
          :error-messages="errors.language_id"
          @change="updateValue('language_id', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="form.gender_id"
          :items="genders"
          item-text="name"
          item-value="id"
          :clearable="!readonly"
          :label="$t('PROFILE.GENDER')"
          :readonly="readonly"
          :error-messages="errors.gender"
          @change="updateValue('gender_id', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <birthday-input
          v-model="form.birthday"
          :error-messages="errors.birthday"
          :readonly="readonly"
          :label="$t('PROFILE.BIRTH_DATE')"
          @input="updateValue('birthday', $event)"
        />
      </v-col>
    </v-row>

    <v-row class="mt-3">
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.street"
          name="street"
          :label="$t('PROFILE.STREET')"
          :readonly="readonly"
          :error-messages="errors.street"
          @input="updateValue('street', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <zip-code-input
          v-model="form.zip"
          :readonly="readonly"
          :error-messages="errors.zip"
          @input="updateValue('zip', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.city"
          name="city"
          :label="$t('PROFILE.CITY')"
          :readonly="readonly"
          :error-messages="errors.city"
          @input="updateValue('city', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { dateFormat } from '@/modules/_global/filters';
import ZipCodeInput from '@/modules/_global/_components/zip/ZipCodeInput';
import formEditable from '@/modules/_global/mixins/form-editable';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { mapCacheActions } from 'vuex-cache';
import BirthdayInput from '@/modules/_global/_components/birthday/BirthdayInput';
import { requiredTextLine } from '@/modules/_global/variables/rules.js';

export default {
  name: 'EmployeeMainInfoForm',

  components: { BirthdayInput, ZipCodeInput },

  filters: {
    dateFormat
  },

  mixins: [formEditable, i18nRefreshData],

  data() {
    return {
      form: {
        first_name: null,
        gender_id: null,
        birthday: null,
        language_id: 1,
        last_name: null,
        salutation_id: null
      },
      rules: {
        requiredTextLine
      },
      salutations: [],
      genders: [],
      languages: []
    };
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('person', ['getSalutations', 'getGenders']),
    ...mapCacheActions('localization', ['retrieveLanguages']),

    refreshData() {
      this.getSalutations().then(({ data }) => {
        this.salutations = data.data;
      });
      this.getGenders().then(({ data }) => {
        this.genders = data.data;
      });
      this.retrieveLanguages().then(response => {
        this.languages = response.data;
      });
    }
  }
};
</script>
